/**
 * Ref set by the Active Chats page on mount/unmount.
 * Used by useSocket to know when the user is viewing the active chats page
 * (so we can avoid playing notification sound in that case).
 */
export const isOnActiveChatsPageRef = { current: false };

export function setOnActiveChatsPage(value: boolean) {
  isOnActiveChatsPageRef.current = value;
}
